export const ANON_LOGIN_FOR_MEETING = '/api/meeting/set-username';

export const ANON_GET_MEETING_DETAIL =
  '/api/meeting/get-external-meeting-details';
